import Rest from '../Rest'

export default class PositionService extends Rest {
  /**
   * @type {String}
   */
  static resource = '/api/v1/positions'

  static build(vs: any = null) {
    return new this(this.resource, null, vs)
  }
}
